import * as Actions from '../../actions/customerVehicleSearch/type';

const initialState = {
  searchCustomerVehicleLoading: false,
  searchCustomerVehicleResults: '',
  searchCustomerVehicleError: '',

  // close more vehicles popup when user search the customer or vehicle
  vehicleExpansionClose: false,

  // vehicles of selected customers
  vehiclesOfSelecteCustomer: [],

  // selected customer data vehicle
  selectedCustomerAndVehicle: '',

  selectedVehicleFromVinPlateSearchList: '',
  vehiclesOfVinPlateSearchResults: [],

  getYearsLoading: false,
  getYears: [],
  getYearsError: '',

  getMakesLoading: false,
  getMakes: [],
  getMakesError: '',

  getModelsLoading: false,
  getModels: [],
  getModelsError: '',

  getEnginesLoading: false,
  getEngines: [],
  getEnginesError: '',
};

export default function (state = initialState, action) {
  switch (action.type) {
    // Search Customer and Vehicle

    case Actions.SEARCH_CUSTOMER_VEHICLE_REQUEST:
      return { ...state, searchCustomerVehicleLoading: true };
    case Actions.SEARCH_CUSTOMER_VEHICLE_SUCCESS:
      return {
        ...state,
        searchCustomerVehicleLoading: false,
        searchCustomerVehicleResults: action.payload || '',
      };
    case Actions.SEARCH_CUSTOMER_VEHICLE_FAIL:
      return {
        ...state,
        searchCustomerVehicleLoading: false,
        searchCustomerVehicleError: action.payload,
      };
    case Actions.CLEAR_SEARCH_CUSTOMER_VEHICLE_STATE:
      return {
        ...state,
        searchCustomerVehicleLoading: false,
        searchCustomerVehicleResults: '',
        searchCustomerVehicleError: '',
      };

    // Close More Vehicles Popup On Search Customer or Vehicle

    case Actions.CLOSE_MORE_VEHICLES_POPUP_ON_SEARCH:
      return { ...state, vehicleExpansionClose: action.payload };

    // Set Vehicles Of Selected Customer

    case Actions.SET_VEHICLES_OF_SELECTED_CUSTOMER:
      return { ...state, vehiclesOfSelecteCustomer: action.payload };

    // selected Customer and Vehicle

    case Actions.SET_SELECTED_CUSTOMER_AND_VEHICLE:
      return { ...state, selectedCustomerAndVehicle: action.payload || '' };

    // update selected vehicle images
    case Actions.UPDATE_VEHICLE_IMAGES:
      let vehicle = state.selectedCustomerAndVehicle?.vehicle || '';

      if (vehicle?.id === action.payload?.data?.id) {
        vehicle = {
          ...vehicle,
          ...(action.payload.data || ''),
        };
      }

      return {
        ...state,

        selectedCustomerAndVehicle: {
          ...state.selectedCustomerAndVehicle,
          vehicle,
        },
      };

    // set vehicle of vin or plate search dropdown

    case Actions.SET_VEHICLE_FROM_VIN_PLATE_SEARCH_LIST:
      return {
        ...state,
        selectedVehicleFromVinPlateSearchList: action.payload || '',
      };

    // set vehicles of vin or plate search
    case Actions.SET_VEHICLES_FROM_VIN_PLATE_SEARCH_RESULTS:
      return {
        ...state,
        vehiclesOfVinPlateSearchResults: action.payload || [],
      };

    // clear vin plate search states

    case Actions.CLEAR_STATES_OF_VIN_PLATE_SEARCH_RESULTS:
      return {
        ...state,
        selectedVehicleFromVinPlateSearchList: '',
        vehiclesOfVinPlateSearchResults: [],
      };

    // Clear States

    case Actions.CLEAR_ALL_SEARCH_CUSTOMER_VEHICLE_STATES:
      return {
        ...state,
        searchCustomerVehicleLoading: false,
        searchCustomerVehicleResults: '',
        searchCustomerVehicleError: '',

        // close more vehicles popup when user search the customer or vehicle
        vehicleExpansionClose: false,

        // vehicles of selected customers
        vehiclesOfSelecteCustomer: [],

        // selected customer data vehicle
        selectedCustomerAndVehicle: '',

        selectedVehicleFromVinPlateSearchList: '',
        vehiclesOfVinPlateSearchResults: [],
      };

    // get years

    case Actions.GET_YEARS_REQUEST:
      return { ...state, getYearsLoading: true };
    case Actions.GET_YEARS_SUCCESS:
      return {
        ...state,
        getYearsLoading: false,
        getYears: action.payload?.data || [],
      };
    case Actions.GET_YEARS_FAIL:
      return {
        ...state,
        getYearsLoading: false,
        getYearsError: action.payload,
      };
    // get makes

    case Actions.GET_MAKES_REQUEST:
      return {
        ...state,

        getMakesLoading: true,
      };
    case Actions.GET_MAKES_SUCCESS:
      return {
        ...state,
        getMakesLoading: false,
        getMakes: action.payload?.data || [],
      };
    case Actions.GET_MAKES_FAIL:
      return {
        ...state,
        getMakesLoading: false,
        getMakesError: action.payload,
      };

    // get models

    case Actions.GET_MODELS_REQUEST:
      return {
        ...state,

        getModelsLoading: true,
      };
    case Actions.GET_MODELS_SUCCESS:
      return {
        ...state,
        getModelsLoading: false,
        getModels: action.payload?.data || [],
      };
    case Actions.GET_MODELS_FAIL:
      return {
        ...state,
        getModelsLoading: false,
        getModelsFail: action.payload,
      };

    // get engines

    case Actions.GET_ENGINES_REQUEST:
      return { ...state, getEnginesLoading: true };
    case Actions.GET_ENGINES_SUCCESS:
      return {
        ...state,
        getEnginesLoading: false,
        getEngines: action.payload?.data || [],
      };
    case Actions.GET_ENGINES_FAIL:
      return {
        ...state,
        getEnginesLoading: false,
        getEnginesError: action.payload,
      };

    // show vehicle information on header

    case Actions.SET_VEHICLE_INFO_ON_HEADER:
      return {
        ...state,
        vehicleInfo: action.payload,
      };

    default:
      return state;
  }
}
